import { useEffect, useState } from "react";
import { Survey } from "survey-react-ui";
import { Model, settings } from "survey-core";
import "survey-core/defaultV2.css";
import { getSafeLocale } from "../utils/surveyLocalization";

const PatientAdvancedSurveyForm = ({ surveyJson, answerJson, language }) => {
  const [model, setModel] = useState(null);

  useEffect(() => {
    if (!surveyJson || typeof surveyJson !== "object") {
      console.warn("Invalid or missing survey_json", surveyJson);
      return;
    }

    try {
      settings.readOnly.enableValidation = true;

      const surveyModel = new Model(surveyJson);

      surveyModel.locale = getSafeLocale(language);
      surveyModel.mode = "display";
      surveyModel.showCompletedPage = false;
      surveyModel.data = answerJson || {};

      setModel(surveyModel);
    } catch (error) {
      console.error("Failed to initialize SurveyJS:", error);
    }
  }, [surveyJson, answerJson]);

  if (!model) {
    return <div style={{ color: "#888" }}>Survey definition not available</div>;
  }

  return <Survey model={model} />;
};

export default PatientAdvancedSurveyForm;
